<template>
  <div>
    <div class="values-wrapper">
      <span v-if="preStr">{{ preStr }}</span>
      <span>{{ firstValue }}</span>
      <span class="dash">-</span>
      <span>{{ secondValue }}</span>
      <span v-if="postStr">&nbsp;{{ postStr }}</span>
    </div>
    <el-slider
      v-model="sliderValue"
      range
      :min="minValue"
      :max="maxValue"
      :show-tooltip="false"
      class="px-3"
      :style="{ marginTop: getIndent }"
      @change="handleChange"
    />
  </div>
</template>

<script>
export default {
  name: 'Slider',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    minValue: {
      type: Number,
      default: undefined
    },
    maxValue: {
      type: Number,
      default: undefined
    },
    indent: {
      type: Number,
      default: 0
    },
    preStr: {
      type: String,
      default: ''
    },
    postStr: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      sliderValue: null
    }
  },
  computed: {
    getIndent() {
      return this.indent + 'px'
    },
    firstValue() {
      //  check if sliderValue contain min and max value
      return this.sliderValue ? this.sliderValue[0] : this.minValue
    },
    secondValue() {
      return this.sliderValue ? this.sliderValue[1] : this.maxValue
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.sliderValue = this.value ?? [this.minValue, this.maxValue]
      }
    }
  },
  methods: {
    handleChange(val) {
      this.$emit('changeValue', val)
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/css/variables.scss';
.cost-slider input {
  max-width: 40px;
}
.age-slider input {
  max-width: 22px;
}
.values-wrapper {
  display: flex;
  font-size: 16px;
  font-weight: lighter;
}
.dash {
  width: 16px;
  text-align: center;
}
.el-slider__bar {
  background-color: $primary !important;
}
@media (min-width: 992px) {
  .values-wrapper {
    font-size: 18px;
  }
}
</style>
